import { axiosInstance } from "../../../config/api/Axios";

export const updateGeneralSettings = (id, userData) => axiosInstance.patch(`/users/${id}/settings/general`, userData);

export const updateSecuritySettings = (id, userData) => axiosInstance.patch(`/users/${id}/settings/security`, userData);

export const updatePreferenceSettings = (id, userData) => axiosInstance.patch(`/users/${id}/settings/preferences`, userData);
